import React from 'react';

const QuestionLine = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
      <defs></defs>
      <path fill='none' d='M0 0h20v20H0z' />
      <path
        d='M8.333 16.667a8.333 8.333 0 1 1 8.333-8.333 8.333 8.333 0 0 1-8.333 8.333z'
        fill='var(--theme-primary, #810ea9)'
        transform='translate(1.667 1.667)'
      />
      <path fill='#eff0f1' d='M6.667 13.333A6.667 6.667 0 1 0 0 6.667a6.667 6.667 0 0 0 6.667 6.666z' transform='translate(3.333 3.333)' />
      <path d='M0 0h1.667v1.667H0z' fill='var(--theme-primary, #810ea9)' transform='translate(9.167 12.5)' />
      <path
        d='M3.694 5.713v.537H2.027V5a.833.833 0 0 1 .833-.833 1.25 1.25 0 1 0-1.225-1.494L0 2.345a2.918 2.918 0 1 1 3.694 3.368z'
        fill='var(--theme-primary, #810ea9)'
        transform='translate(7.139 5.416)'
      />
    </svg>
  );
};

export default QuestionLine;
